import { Component, Input } from '@angular/core';

@Component({
  selector: 'faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {

  @Input() faqs:Array<any> = [];
  @Input() customClass:string = '';
  @Input() sliceItems:number;

  constructor() { }

}
